module.exports = __webpack_public_path__ + "img/close_sidebar.d8b8f49d.svg";